module.exports = __webpack_public_path__ + "static/media/media.648e6ca2.png";